import { SettingsCard, ToggleField, NumberField } from "./fields";
import type { SettingsTabProps } from "../settings";

export default function GuvenlikKvkk({ settings, update }: SettingsTabProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <SettingsCard
        title="Güvenlik Politikaları"
        description="Oturum ve şifre güvenliği ayarları."
      >
        <div className="space-y-3">
          <ToggleField
            label="Güçlü şifre zorunluluğu"
            description="Şifreler büyük/küçük harf, rakam ve sembol içermelidir."
            checked={settings.requireStrongPassword}
            onChange={(v) => update({ requireStrongPassword: v })}
          />
          <ToggleField
            label="İki faktörlü doğrulama (2FA)"
            description="Yönetici ve öğretmen hesaplarında ikinci doğrulama katmanı istenir."
            checked={settings.twoFactorRequired}
            onChange={(v) => update({ twoFactorRequired: v })}
          />
          <NumberField
            label="Oturum süresi (dakika)"
            value={settings.sessionTimeoutMin}
            onChange={(v) => update({ sessionTimeoutMin: v })}
            min={5}
            max={1440}
            hint="Bu süre sonunda kullanıcı otomatik çıkış yapar."
          />
        </div>
      </SettingsCard>

      <SettingsCard
        title="KVKK & Veri Koruma"
        description="6698 sayılı KVKK kapsamında veri sorumlusu bilgileri."
      >
        <div className="rounded-md bg-accent-100/70 px-4 py-3 text-xs text-accent-900">
          <i className="ri-shield-check-line mr-1" aria-hidden="true"></i>
          Veri sorumlusu olarak "Kurumsal Bilgiler" sekmesindeki unvan ve adres bilgileri kullanılır.
        </div>
      </SettingsCard>
    </div>
  );
}